<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-08-01_avoimet-ovet-ja-dynamobattle";
    let title = "Onnea Dynamosali 10v!!!";
    let titlePic = "/svelte-site/img/ajankohtaista/kansi-1.jpg";
    let firstPara = "Lauantaina 24.8. juhlimme synttäreitä pitämällä avoimet ovet. Luvassa paljon ohjelmaa asiakkaille ja uusille tutustujille - Tervetuloa!";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">

    <a href="/ajankohtaista/{ajankohtaistaUrl}">
        <span class="articleImage"
              style="background-image: url('{titlePic}"></span>
        <span>
        <span class="blogTitle">{title}</span>
        <span class="blogShortContent">{firstPara}</span>
    </span>
    </a>

    </div>
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogMainImage" style="background-image: url('{titlePic}')"></div>


            <h2>Dynamosali on jo 10-vuotias!</h2>

            <p>24.8. vietetään Dynamosalin 10v-synttäreitä, ja tätä juhlistamme pitämällä avoimet ovet kaikille nykyisille, 
                entisille ja ehkäpä tuleville asiakkaille tai muuten kiinnostuneille.</p>

            <p>
                Avoimien ovien päivän aikana on mahdollista mm. ottaa
                tuoreet lukemat InBody-laitteella, kisailla kädenväännössä, kelkan työnnössä, säkin kannossa, sekä
                seurata tai osallistua DynamoBattle-parikilpailuun. Myös salin hieroja ja fysioterapeutti FysioSari on
                paikalla esittelemässä toimintaa klo 12-14.</p>
            <p>Kylillä kiertää myös huhua, että jopa logomies saattaisi pyörähtää paikalla :)</p>
            <p>Tämä on hyvä tilaisuus tuoda myös ystävät ja perheenjäsenet tutustumaan saliimme joko testitreenaten
                taikka vain kakkukahvin merkeissä. Ilmeemme on muuttunut aikojen saatossa ja olemme saaneet myös uusia
                laitteita.</p>
    

            <h2>DynamoBattle</h2>

            <p>DynamoBattle on leikkimielinen kilpailu, jossa adrenaliini virtaa ja ystävyssuhteet syvenevät!
             DynamoBattle on matalan kynnyksen tapahtuma. Tähän osallistuaksesi sinun ei tarvitse olla huippukuntoinen 
             tekijä tai kovan tason konkari. Tänä vuonna parit arvotaan, joten saat mahdollisuuden kokea aivan 
                uudenlaista tiimihenkeä ja yhteistyötä.

                Kisoihin voi ilmoittautua <a href="https://www.facebook.com/share/VmvG7Fzji3Dc4F8Z/" title="Dynamosali 10 vuotta - Avoimet ovet ja DynamoBattle 2024">Facebook-tapahtumassa</a> tai salin seinältä löytyvästä listasta. </p>
                
                <p>Battleen tarvitaan myös tuomareita. Tuomariksi voi ilmoittautua laittamalla nimen salin seinältä löytyvään listaan.</p>




            <h2>Illanvietto Dynamosalin asiakkaille</h2>
            <p>Kaikki Dynamon jäsenet, korttityypistä riippumatta, ovat tervetulleita osallistumaan avoimien ovien
                jälkeiseen illanviettoon. Illan aikana syömisten ääressä käydään tietenkin kisojen jälkipuinnit. Kuka
                teki liikkeet puhtaasti, oliko mankkua liikaa / liian vähän tai olisiko eri painonnostokengillä tullut
                parempi tulos.</p>

                
            <p>Toivomme, että <a href="https://forms.gle/jQu5gEpNAuwm7efLA" title="Ilmoittautumislomake illanviettoon">ilmoittaudut illanviettoon</a> etukäteen, jotta osaamme varautua ohjelmaan ja tarjoiluun.</p>


            <p>
            <a class="bigButton" href="https://www.facebook.com/share/VmvG7Fzji3Dc4F8Z/" target="_blank" title="Facebook-tapahtuma, avautuu uuteen ikkunaan.">Avoimet ovet ja DynamoBattle Facebookissa</a>
             <a class="bigButton" href="https://forms.gle/jQu5gEpNAuwm7efLA" target="_blank" title="Ilmoittautumislomake illanviettoon, avautuu uuteen ikkunaan.">Ilmoittaudu illanviettoon tästä</a>
            </p>

        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
